<template>
  <div class="w-100 h-100 d-flex flex-column player-wrapper">
    <div v-if="course.available || course.keepActive"
         class="v-100 h-100 course-view align-items-center">
      <template v-if="course.fileType === 'PDF'">
        <PdfViewer ref="pdfViewer"/>
      </template>
      <template v-else-if="course.fileType === 'VIDEO'">
        <VideoViewer ref="videoViewer"/>
      </template>
      <template v-else-if="course.fileType === 'VTS'">
        <VTSViewer  ref="vtsViewer"/>
      </template>
      <template v-else-if="course.fileType === 'SCORM'">
        <ScormViewer  ref="scormViewer"/>
      </template>
      <template v-else-if="course.fileType === 'ASSIGNMENT'">
        <AssignmentViewer  ref="assignmentViewer"/>
      </template>
      <template v-else-if="course.fileType === 'QUESTIONNAIRE'">
        <QuestionnaireViewer  ref="questionnaireViewer"/>
      </template>
      <template v-else>
        <ExternalViewer ref="externalViewer"/>
      </template>
    </div>
    <div v-else class="d-flex h-100 align-items-center justify-content-center">
      <div class="position-absolute activity-alert d-flex flex-column"
           :class="{'clear': !organization.darkMode}" >
        <span class="h6 font-weight-bold">{{ getNotAvailableReason() }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store';
import { mapGetters } from 'vuex';
import PdfViewer from '@/views/PdfViewer.vue';
import {
  SET_COURSE, FETCH_COURSES,
} from '@/store/actions.type';
import HelperMixin from '@/mixins/helperMixin';
import ScormViewer from '@/views/ScormViewer.vue';
import VTSViewer from '@/views/VTSViewer.vue';
import VideoViewer from '@/views/VideoViewer.vue';
import ExternalViewer from '@/views/ExternalViewer.vue';
import AssignmentViewer from '@/views/AssignmentViewer.vue';
import QuestionnaireViewer from '@/views/QuestionnaireViewer.vue';

export default {
  name: 'CourseView',
  mixins: [HelperMixin],
  components: {
    QuestionnaireViewer,
    AssignmentViewer,
    ScormViewer,
    VTSViewer,
    VideoViewer,
    PdfViewer,
    ExternalViewer,
  },
  beforeRouteUpdate(to, from, next) {
    const { courseId, sessionId } = to.params;
    if (this.course.available && ((this.$refs.vtsViewer && !this.$refs.vtsViewer.locked)
      || (this.$refs.scormViewer && this.$refs.scormViewer.terminated)
      || (this.$refs.assignmentViewer && this.$refs.assignmentViewer.terminated)
      || (this.$refs.questionnaireViewer && this.$refs.questionnaireViewer.terminated)
      || (this.$refs.videoViewer && this.$refs.videoViewer.completed)
      || (this.$refs.externalViewer && this.$refs.externalViewer.watched)
      || (this.$refs.pdfViewer && (this.$refs.pdfViewer.completed || !this.$refs.pdfViewer.started))
    )) {
      store.dispatch(FETCH_COURSES, sessionId).then(() => {
        this.$Progress.finish();
        store.dispatch(SET_COURSE, courseId);
        if (window.innerWidth < 992) {
          this.$parent.showPath = false;
        }
        next();
      }).catch(() => {
        this.$dialog.alert(this.$t('app.activity.not.available'), {
          html: true,
          okText: this.$t('app.activity.commit.ok'),
        }).then(() => this.$router.push('/my-organization'));
      });
    } else {
      const proceed = async () => {
        try {
          await store.dispatch(FETCH_COURSES, sessionId);
          this.$Progress.finish();
          if (this.$refs.scormViewer) {
            await this.$refs.scormViewer.postData();
          } else if (this.$refs.videoViewer) {
            await this.$refs.videoViewer.postData();
          } else if (this.$refs.pdfViewer) {
            await this.$refs.pdfViewer.postData();
          } else if (this.$refs.externalViewer) {
            await this.$refs.externalViewer.postData();
          }
          store.dispatch(SET_COURSE, courseId);

          if (window.innerWidth < 992) {
            this.$parent.showPath = false;
          }

          next();
        } catch (error) {
          await this.$dialog.alert(this.$t('app.activity.not.available'), {
            html: true,
            okText: this.$t('app.activity.commit.ok'),
          });
          this.$router.push('/my-organization');
        }
      };
      const handleQuit = async () => {
        if (!this.course.available) {
          await proceed();
        } else {
          try {
            await this.$dialog.confirm(this.$t('app.activity.quit.message'), {
              okText: this.$t('app.activity.quit.confirm'),
              cancelText: this.$t('app.activity.quit.cancel'),
            });
            await proceed();
          } catch (error) {
            next(false); // Annulation du dialogue
          }
        }
      };
      handleQuit();
    }
  },

  methods: {
    getNotAvailableReason() {
      let reason = '';
      switch (this.course.notAvailableReason) {
        default: reason = ''; break;
        case 'chapterStartDate': reason = this.$t('app.activity.locked.chapterStartDate', [this.course.chapterName, this.formatDateFull(this.course.chapterStartDate)]); break;
        case 'chapterEndDate': reason = this.$t('app.activity.locked.chapterEndDate', [this.course.chapterName, this.formatDateFull(this.course.chapterEndDate)]); break;
        case 'chapterCompletion': reason = this.$t('app.activity.locked.chapterCompletion', [this.course.notAvailableReasonInfo]); break;
        case 'glueCompletion': reason = this.$t('app.activity.locked.glueCompletion', [this.course.notAvailableReasonInfo]); break;
        case 'restartRule': reason = this.$t('app.activity.locked.restartRule'); break;
      }
      return reason;
    },
  },
  computed: {
    ...mapGetters(['courses', 'course', 'organization', 'currentSession']),
  },
};
</script>
